<template>
  <div>
    <main>
      <section>
        <div class="container">
          <div class="row">
            <div class="col-12 m-b-20">
              <h5 class="spacer-top">Hello, {{ user.firstname }}</h5>
            </div>

            <div class="row stat-tiles spacer-top">
              <div class="col-lg-3 col-md-4 col-sm-6 mb-4">
        <router-link :to="{ path: '/view-clients-agency' }" class="text-decoration-none">
          <div class="card border-0 shadow-sm h-100">
            <div class="card-body py-3 px-4 d-flex align-items-center" style="gap: 14px;">
              <div class="avatar avatar-md flex-shrink-0">
                <div class="avatar-title bg-soft-primary rounded-circle text-primary">
                  <i class="fe fe-users"></i>
                </div>
              </div>
              <div>
                <p class="mb-0 text-muted" style="font-size: .72rem; text-transform: uppercase; letter-spacing: .04em;">Total Informal Enrollees</p>
                <h4 class="mb-0 font-weight-bold text-dark">{{ (informaldata.bhcpf + informaldata.phi + informaldata.voluntary + informaldata.unicef) | numeral(0, 0) }}</h4>
              </div>
            </div>
          </div>
        </router-link>
      </div>
              <div class="col-lg-3 col-md-4 col-sm-6 mb-4">
        <router-link :to="{ path: '/view-clients-agency' }" class="text-decoration-none">
          <div class="card border-0 shadow-sm h-100">
            <div class="card-body py-3 px-4 d-flex align-items-center" style="gap: 14px;">
              <div class="avatar avatar-md flex-shrink-0">
                <div class="avatar-title bg-soft-info rounded-circle text-info">
                  <i class="fe fe-users"></i>
                </div>
              </div>
              <div>
                <p class="mb-0 text-muted" style="font-size: .72rem; text-transform: uppercase; letter-spacing: .04em;">Basic Healthcare Provision Fund</p>
                <h4 class="mb-0 font-weight-bold text-dark">{{ informaldata.bhcpf | numeral(0, 0) }}</h4>
              </div>
            </div>
          </div>
        </router-link>
      </div>
              <!-- <div class="col-lg-3 col-md-4 col-sm-6 mb-4">
        <router-link :to="{ path: '/view-clients-agency' }" class="text-decoration-none">
          <div class="card border-0 shadow-sm h-100">
            <div class="card-body py-3 px-4 d-flex align-items-center" style="gap: 14px;">
              <div class="avatar avatar-md flex-shrink-0">
                <div class="avatar-title bg-soft-success rounded-circle text-success">
                  <i class="fe fe-users"></i>
                </div>
              </div>
              <div>
                <p class="mb-0 text-muted" style="font-size: .72rem; text-transform: uppercase; letter-spacing: .04em;">Pro Health International</p>
                <h4 class="mb-0 font-weight-bold text-dark">{{ informaldata.phi | numeral(0, 0) }}</h4>
              </div>
            </div>
          </div>
        </router-link>
      </div> -->
              <div class="col-lg-3 col-md-4 col-sm-6 mb-4">
        <router-link :to="{ path: '/plans' }" class="text-decoration-none">
          <div class="card border-0 shadow-sm h-100">
            <div class="card-body py-3 px-4 d-flex align-items-center" style="gap: 14px;">
              <div class="avatar avatar-md flex-shrink-0">
                <div class="avatar-title bg-soft-warning rounded-circle text-warning">
                  <i class="fe fe-users"></i>
                </div>
              </div>
              <div>
                <p class="mb-0 text-muted" style="font-size: .72rem; text-transform: uppercase; letter-spacing: .04em;">Voluntary Contributor</p>
                <h4 class="mb-0 font-weight-bold text-dark">{{ informaldata.voluntary | numeral(0, 0) }}</h4>
              </div>
            </div>
          </div>
        </router-link>
      </div>

              <div class="col-lg-3 col-md-4 col-sm-6 mb-4">
        <router-link :to="{ path: '/view-clients-agency' }" class="text-decoration-none">
          <div class="card border-0 shadow-sm h-100">
            <div class="card-body py-3 px-4 d-flex align-items-center" style="gap: 14px;">
              <div class="avatar avatar-md flex-shrink-0">
                <div class="avatar-title bg-soft-dark rounded-circle text-dark">
                  <i class="fe fe-credit-card"></i>
                </div>
              </div>
              <div>
                <p class="mb-0 text-muted" style="font-size: .72rem; text-transform: uppercase; letter-spacing: .04em;">UNICEF</p>
                <h4 class="mb-0 font-weight-bold text-dark">{{ informaldata.unicef }}</h4>
              </div>
            </div>
          </div>
        </router-link>
      </div>

              <div class="col-lg-3 col-md-4 col-sm-6 mb-4">
        <router-link :to="{ path: '/plans' }" class="text-decoration-none">
          <div class="card border-0 shadow-sm h-100">
            <div class="card-body py-3 px-4 d-flex align-items-center" style="gap: 14px;">
              <div class="avatar avatar-md flex-shrink-0">
                <div class="avatar-title bg-soft-primary rounded-circle text-primary">
                  <i class="fe fe-users"></i>
                </div>
              </div>
              <div>
                <p class="mb-0 text-muted" style="font-size: .72rem; text-transform: uppercase; letter-spacing: .04em;">Dependents</p>
                <h4 class="mb-0 font-weight-bold text-dark"><!-- {{ informaldata.dependants | numeral(0, 0) }} --> 0</h4>
              </div>
            </div>
          </div>
        </router-link>
      </div>

              <div class="col-lg-3 col-md-4 col-sm-6 mb-4">
        <router-link :to="{ path: '/my-providers' }" class="text-decoration-none">
          <div class="card border-0 shadow-sm h-100">
            <div class="card-body py-3 px-4 d-flex align-items-center" style="gap: 14px;">
              <div class="avatar avatar-md flex-shrink-0">
                <div class="avatar-title bg-soft-danger rounded-circle text-danger">
                  <i class="fe fe-activity"></i>
                </div>
              </div>
              <div>
                <p class="mb-0 text-muted" style="font-size: .72rem; text-transform: uppercase; letter-spacing: .04em;">Health Facilities</p>
                <h4 class="mb-0 font-weight-bold text-dark">{{ informaldata.providers }}</h4>
              </div>
            </div>
          </div>
        </router-link>
      </div>

              <div class="col-lg-3 col-md-4 col-sm-6 mb-4">
        <router-link :to="{ path: '/list-records' }" class="text-decoration-none">
          <div class="card border-0 shadow-sm h-100">
            <div class="card-body py-3 px-4 d-flex align-items-center" style="gap: 14px;">
              <div class="avatar avatar-md flex-shrink-0">
                <div class="avatar-title bg-soft-primary rounded-circle text-primary">
                  <i class="fe fe-file-plus"></i>
                </div>
              </div>
              <div>
                <p class="mb-0 text-muted" style="font-size: .72rem; text-transform: uppercase; letter-spacing: .04em;">Encounters</p>
                <h4 class="mb-0 font-weight-bold text-dark">{{ informaldata.encounters }}</h4>
              </div>
            </div>
          </div>
        </router-link>
      </div>
            </div>

            <!-- <FilterUserDate /> -->
          </div>

          <div class="container col-md-12 mb-5">
            <div class="row">
              <router-link to="export-date">
                <button class="btn btn-outline-info mr-2">
                  Filter Enrollee Date
                </button>
              </router-link>

              <router-link to="export-provider">
                <button class="btn btn-outline-dark">
                  Filter Enrollee Provider
                </button>
              </router-link>
            </div>
          </div>

          <div>
            <InformalLga />
          </div>

          <div>
            <EnrolleebyLGAandFacility />
          </div>

          <div>
            <VulnerableByLGA />
          </div>

          <div class="row">
            <div class="col-md-12 p-t-20">
              <h5 class="h5">
                <i class="fe fe-activity"></i>Gender Distribution by LGA
              </h5>
            </div>

            <div class="col-md-12">
              <div class="card table-card shadow mb-4">
                <div class="card-body">
                  <GenderbyLGA :sectors="sectors" />
                </div>
              </div>
            </div>
          </div>

          <h5 class="h5">
            <i class="fe fe-activity"></i> Category of Informal Sector Data
          </h5>
          <div class="row">
            <div class="col-md-6">
              <BasicCategory />
            </div>
            <div class="col-md-6">
              <genderCategory />
            </div>
          </div>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
import VulnerableByLGA from "./VulnerableByLGA";
import InformalLga from "./informallga";
import BasicCategory from "./basicCategory";
import genderCategory from "./genderCategory";
import EnrolleebyLGAandFacility from "./EnrolleebyLGAandFacility";
import GenderbyLGA from "./GenderbyLGA";

export default {
  components: {
    VulnerableByLGA,
    GenderbyLGA,
    EnrolleebyLGAandFacility,
    genderCategory,
    InformalLga,
    BasicCategory,
  },

  data() {
    return {
      user: null,
      informaldata: "",
      mydata: "",
      totalusers: "",
      providers: "",
      clients: "",
      total_clients: "",
      sectors: [
        {
          name: "Basic Healthcare Provision Fund",
        },
        {
          name: "State Equity Program",
        },
        {
          name: "Pro Health International",
        },
         {
          name: "UNICEF",
        },
         {
          name: "GAVI",
        },
      ],
      offlineclients: [],
      employees: "",
      plans: "",
      tpas: "",
    };
  },
  beforeMount() {
    this.user = JSON.parse(localStorage.getItem("user"));
    this.$batchGet("/api/v1/auth/getinformalsectorenrollees/4")
      .then((response) => {
        this.informaldata = response.data;
        console.log(response);
      })
      .catch((error) => {
        console.error(error);
      });
  },
  computed: {
    totalEnrollees() {
      let total = 0;
      for (let i = 0; i < this.totalusers.length; i++) {
        total += parseInt(this.totalusers[i].y);
      }
      return total;
    },
  },

  methods: {},
  created() {},
};
</script>
<style lang="css" scoped>
.spacer-top {
  margin-top: 10px;
}
</style>
